import { useState } from 'react';
import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function HotRecommend() {
  const [activeTab, setActiveTab] = useState<'hot' | 'new'>('hot');

  const hotComics = comics.filter((c) => c.isHot);
  const newComics = comics.filter((c) => c.isNew);
  const displayComics = activeTab === 'hot' ? hotComics : newComics;

  return (
    <section id="hot-recommend" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              精选优质韩漫，发现你的下一部心头好
            </p>
          </div>
          <div className="flex items-center bg-background-200 rounded-full p-1">
            <button
              onClick={() => setActiveTab('hot')}
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                activeTab === 'hot'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              热门韩漫
            </button>
            <button
              onClick={() => setActiveTab('new')}
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                activeTab === 'new'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              新番上架
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {displayComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}